import { SKAN_UNIFIED_NAMESPACE } from '../../../../shared/constants';
import { UnifiedAdsDrilldownMigrator } from '../../../../shared/services/UnifiedAdsDrilldownMigrator';
import type { ShareableData, SkanUnifiedSharableData } from '../types/shareableTypes';
import type { IShareableStateMigrator } from './ShareableStateMigratorService';

export class ShareableUnifiedAdsMigratorService implements IShareableStateMigrator {
  static build() {
    return new ShareableUnifiedAdsMigratorService();
  }

  private drilldownMigrator: UnifiedAdsDrilldownMigrator<SkanUnifiedSharableData>;

  constructor() {
    this.drilldownMigrator = new UnifiedAdsDrilldownMigrator<SkanUnifiedSharableData>();
  }

  async migrate(state: ShareableData) {
    const skanUnified: SkanUnifiedSharableData = state[SKAN_UNIFIED_NAMESPACE];
    if (skanUnified) {
      await this.drilldownMigrator.migrate(skanUnified);
    }
  }
}
